import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StudyReportLogisticsCommentService } from '../../../services/study-report/study-report-logistics-comment.service';
import { StudyReportLogisticsComment } from '../../../model/study-report/study-report-logistics-comment';


export interface StudyReportLogisticsCommentDialogEditRequest {
  studyReportId: number; 
}
 
@Component({
  selector: 'app-study-report-logistics-comment-dialog',
  templateUrl: './study-report-logistics-comment-dialog.component.html',
  styleUrls: ['./study-report-logistics-comment-dialog.component.css']
})
export class StudyReportLogisticsCommentDialogComponent implements OnInit {

  form: FormGroup;
  comments: StudyReportLogisticsComment[] = [];
  saving:  boolean = false;

  constructor(
    public dialogRef: MatDialogRef<StudyReportLogisticsCommentDialogComponent>,
     private formBuilder: FormBuilder,
     private service: StudyReportLogisticsCommentService, 
     @Inject(MAT_DIALOG_DATA) public request: StudyReportLogisticsCommentDialogEditRequest) {
      this.form = this.formBuilder.group({
        comment: ['', Validators.required]
      });
    }

  get f() { return this.form.controls; }

  async ngOnInit() {
    this.comments = await this.service.GetByStudyReportId(this.request.studyReportId); 
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() { 
    console.log(this.form);
    if ( this.form.valid ) {
        this.saving = true; 
        await this.service.create(this.f.comment.value, this.request.studyReportId);
        this.saving = false;
        this.dialogRef.close();
    }
  }
}
